export default {
  hytj:'货运统计',
  tjhz:'统计汇总',
  qb:'全部',
  fh:'发货',
  sh:'收货',
  tjfs:'统计方式',
  jyn:'近一年',
  jyy:'近一月',
  tjsjjzzr:'统计数据截止昨日',
  hwzz:'货物总重',
  wd:'万吨',
  tb:'同比',
  hb:'环比',
  fhhwzz:'发货货物总重',
  shhwzz:'收货货物总重',
  ljxf:'累计消费',
  wy:'万元',
  my:'美元',
  jp:'基普',
  zjfhjj:'最近发货距今',
  zjshjj:'最近收货距今',
  tian:'天',
  fwqy:'服务企业',
  zysfhwpl:'主要收发货物品类',
  dw:'单位',
}
